import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import { setDocumentTitle, setUidToken, isRtl } from 'src/helper/tool'
import { getlangV2, setlang } from 'src/helper/getlang'
import localstorage from 'src/helper/localstorage'
import Toast from 'src/component/Toast'
import Rule from './Rule'
import Top from './Top'
import Reward from './Reward'
import GroupList from './GroupList'
import Loading from 'src/component/Loading'
import scroll from 'src/helper/scroll'
import { history } from 'src/core/router'
import langM from './lang'
import { jumpToUser } from 'src/helper/webviewFun'
@inject('store')
@observer
export default class extends React.Component {
  constructor(props) {
    super(props)
    this.store = this.props.store.register('app/roomsupport-register')
  }
  state = {
    loading: false,
    lang: langM.ar,
    nav: 1,
    weekNav: 1,
    language:'en',
  }

  hideRule = async (status) => {
    if (status) {
      this.$logEvent("roomSupport_rule")
    }
    this.refs.rule.hideRule(status)
  }

  async componentWillMount() {
    let { language } = this.props.location.query
    language =await getlangV2(language, langM)
    // console.log("language", language)
    let lang2 = await setlang(language, langM)
    // console.log(111, lang2, langM)
    this.setState({
      lang: lang2,
      language: language
    })
    let uid = await setUidToken(this.props.location.query)
    await this.RunOnStart(uid)
  }

  async RunOnStart(uid) {
    this.store.GetUserInfoWeb(uid)
    await this.store.groupRank(true, 1)
    await this.store.groupRank(true, 2)
  }

  async componentDidMount() {
    this.$logEvent("roomSupport_main_screen")
    //之前看了几次图
    let uid = await this.store.data

    let seeTiger = await localstorage.get(`seeTiger${uid}`)
    seeTiger = parseInt(seeTiger)
    if (seeTiger > 0) {
    } else {
      seeTiger = 0
    }

    window.addEventListener('scroll', this.loadMore, false)

    setTimeout(() => {
      setDocumentTitle(this.state.lang.toptitle)
    }, 1000)
  }

  loadMore = () => {
    let bottom = scroll.checkButtom()
    if (bottom) {
      // 如果拉到底部
      console.log('拉到底部', this.state.nav)
      if (this.state.weekNav == 1) {
        this.store.groupRank(false, 1)
      }
      if (this.state.weekNav == 2) {
        this.store.groupRank(false, 2)
      }
    }
  }

  changeNav = async (nav) => {
    this.setState({
      nav: nav
    })
  }

  changeWeekNav = async (nav) => {
    this.setState({
      weekNav: nav
    })
  }

  tabContent2 = (language, list1, list2) => {
    let { lang, weekNav } = this.state
    return (
      <div className={`tabContent2 ${this.state.nav == 2 ? 'block' : 'none'}`}>
        <div className="back" onClick={this.changeNav.bind(this, 1)}>
          <img className="backP" src="/img/app/roomsupport/back.png" />
          <div className="txt">{lang.back}</div>
        </div>
        <div style={{ height: '0.12rem' }}></div>
        <GroupList
          language={language}
          lang={this.state.lang}
          list={list2}
          listThis={list1}
          nav={weekNav}
          changeWeekNav={this.changeWeekNav.bind(this)}
        />
      </div>
    )
  }

  tabContent3 = (language, countryId) => {
    // let { lang } = this.state
    return (
      <div className={`tabContent3 ${this.state.nav == 1 ? 'block' : 'none'}`}>
        {/* <div style={{ height: '1rem' }}></div> */}
        <Reward language={language} lang={this.state.lang} />
        {/* {countryId == 138 && ( */}
        {/* <div className="view" onClick={this.changeNav.bind(this, 2)}>
            {lang.viewMyCountry} >>>
          </div> */}
        {/* )} */}
      </div>
    )
  }

  showTableBg =(language)=>{

    switch (language) {
      case 'en':
        return (
          <div className='table-bg'>
             <img src='/img/app/roomsupport/table_enone.png' className='bg_one'></img>
             <img src='/img/app/roomsupport/table_entwo.png' className='bg_two'></img>
          </div>
        )
        break;
        case 'tr':
        return (
          <div className='table-bg'>
             <img src='/img/app/roomsupport/table_trone.png' className='bg_one'></img>
             <img src='/img/app/roomsupport/table_trtwo.png' className='bg_two'></img>
          </div>
        )
        break;
        case 'ar':
        return (
          <div className='table-bg'>
             <img src='/img/app/roomsupport/table_arone.png' className='bg_one'></img>
             <img src='/img/app/roomsupport/table_artwo.png' className='bg_two'></img>
          </div>
        )
        break;
      default:
        return (
          <div className='table-bg'>
             <img src='/img/app/roomsupport/table_en_one.png' className='bg_one'></img>
             <img src='/img/app/roomsupport/table_en_two.png' className='bg_two'></img>
          </div>
        )
        break;
    }
    
  }

  gotoR = () => {
    this.$logEvent("roomSupport_register")
    let { uid, accesstoken } = localstorage.get('userInfo')
    history.push(`/app/roomsupport-op?uid=${uid}&accesstoken=${accesstoken}&language=${this.state.language}`)
  }


  render(){
    let { language, lang } = this.state
    return <div className={`roomsupport04 ${isRtl(language) && 'arlang'}`}>
      <div className='rmeisehjh'>
            <div className='tnenw'>{lang.setTest}</div>
         </div>
    </div>
  }
}



// WEBPACK FOOTER //
// src/pages/app/roomsupport/index.js